import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "input-box__icon input-icon"
}
const _hoisted_2 = ["name", "type", "value", "placeholder", "disabled"]
const _hoisted_3 = {
  key: 3,
  class: "input-box__error"
}

import { ref, watch, onBeforeMount, computed } from 'vue';


const __default__ = {
  name: 'vita-input'
}

interface Props {
  placeholder?: string
  modelValue: string
  type: string
  mask?: string
  error?: string
  icon?: string
  disabled?: boolean
  secondaryStyle?: string
  inputName?: string
  floatingLabel?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    placeholder: {},
    modelValue: {},
    type: { default: 'text' },
    mask: {},
    error: {},
    icon: {},
    disabled: { type: Boolean },
    secondaryStyle: {},
    inputName: {},
    floatingLabel: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const focus = ref(false)
const inputRef = ref<HTMLInputElement | null>(null); // Ref для внутреннего input

const emit = __emit;

const passwordIcon = ref(true);
const inputType = ref('text');
const showPassword = () => {
  passwordIcon.value = !passwordIcon.value
}

onBeforeMount(() => {
  inputType.value = props.type
})

const handleChange = (event: Event) => {
  const newValue = (event.target as HTMLInputElement).value;
  emit('update:modelValue', newValue);
};

const focusInput = (i:boolean) => {
  focus.value = i
}

watch(passwordIcon, (val: boolean) => {
  inputType.value = !val ? 'text' : 'password'
});

// Если у поля есть иконка, плавающий label отключается
const floatingLabelComputed = computed(() => props.floatingLabel && !props.icon);

// Экспортируем метод focus
__expose({
  focus: () => {
    if (inputRef.value) {
      inputRef.value.focus();
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_vita_icon = _resolveComponent("vita-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-box", {focus: focus.value, disabled: __props.disabled, 'secondary' : __props.secondaryStyle, 'is-floating': __props.floatingLabel}])
  }, [
    (__props.icon)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createVNode(_component_vita_icon, { name: __props.icon }, null, 8, ["name"])
        ]))
      : _createCommentVNode("", true),
    (__props.placeholder && floatingLabelComputed.value)
      ? (_openBlock(), _createElementBlock("label", {
          key: 1,
          class: _normalizeClass({ active: focus.value || __props.modelValue.length })
        }, _toDisplayString(__props.placeholder), 3))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      ref_key: "inputRef",
      ref: inputRef,
      name: __props.inputName,
      type: inputType.value,
      value: __props.modelValue,
      placeholder: floatingLabelComputed.value ? '' : __props.placeholder,
      onFocus: _cache[0] || (_cache[0] = ($event: any) => (focusInput(true))),
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (focusInput(false))),
      onInput: handleChange,
      disabled: __props.disabled
    }, null, 40, _hoisted_2),
    (__props.type === 'password')
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: "input-box__icon password-icon",
          onClick: showPassword,
          "data-qa": "input-icon-toggle-password"
        }, [
          (__props.modelValue.length)
            ? (_openBlock(), _createBlock(_component_vita_icon, {
                key: 0,
                name: passwordIcon.value ? 'eye' : 'open-eye'
              }, null, 8, ["name"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (__props.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.error), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})